import React, { useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../firebase';
import { setDoc, doc } from 'firebase/firestore';
import Swal from 'sweetalert2';
import { Box, Paper, TextField, Button, Typography, CircularProgress } from '@mui/material';

function Register() {
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
  });

  const signup = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await createUserWithEmailAndPassword(auth, username, password);
      const user = auth.currentUser;
      if (user) {
        await setDoc(doc(db, "authroles", user.uid), {
          email: user.email,
          mobile: mobile,
          username: name,
          password: password,
          uid: user.uid,
          role: "General Man"
        });
      }
      Toast.fire({ icon: "success", title: 'User Registered Successfully!!' });
      window.location.href = "/home";
    } catch (error) {
      Toast.fire({ icon: 'error', title: 'Error: Please check your details' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        height: '100vh',
        background: '#1a2a4f',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Abstract Floating Circles */}
      {[...Array(6)].map((_, i) => (
        <Box
          key={i}
          sx={{
            position: 'absolute',
            width: `${50 + Math.random() * 100}px`,
            height: `${50 + Math.random() * 100}px`,
            borderRadius: '50%',
            background: i % 2 === 0 ? 'rgba(212,175,55,0.15)' : 'rgba(253,246,227,0.12)',
            top: `${-200 - i * 100}px`,
            left: `${i * 15 + 10}%`,
            filter: 'blur(80px)',
            animation: `fall ${10 + i * 3}s linear infinite`,
            zIndex: 0,
          }}
        />
      ))}

      <Paper
        elevation={10}
        sx={{
          width: '90%',
          maxWidth: 450,
          p: 5,
          borderRadius: 4,
          textAlign: 'center',
          backdropFilter: 'blur(15px)',
          background: 'rgba(15,61,62,0.85)', // Dark Teal glass
          border: '1px solid rgba(212,175,55,0.4)',
          color: '#fdf6e3', // Cream text
          position: 'relative',
          zIndex: 1,
        }}
      >
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          TTXPLORE
        </Typography>
        <Typography variant="body2" sx={{ mb: 3, opacity: 0.85 }}>
          Register your account
        </Typography>

        <form onSubmit={signup}>
          <TextField
            label="Full Name"
            variant="filled"
            fullWidth
            sx={{
              mb: 3,
              input: { color: '#fdf6e3' },
              label: { color: 'rgba(253,246,227,0.8)' },
              "& .MuiFilledInput-root": { background: 'rgba(212,175,55,0.1)', borderRadius: 2 },
              "& .MuiFilledInput-root:before": { borderBottom: 'none' },
            }}
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />

          <TextField
            label="Mobile Number"
            variant="filled"
            fullWidth
            sx={{
              mb: 3,
              input: { color: '#fdf6e3' },
              label: { color: 'rgba(253,246,227,0.8)' },
              "& .MuiFilledInput-root": { background: 'rgba(212,175,55,0.1)', borderRadius: 2 },
              "& .MuiFilledInput-root:before": { borderBottom: 'none' },
            }}
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            required
          />

          <TextField
            label="Email / Username"
            variant="filled"
            fullWidth
            sx={{
              mb: 3,
              input: { color: '#fdf6e3' },
              label: { color: 'rgba(253,246,227,0.8)' },
              "& .MuiFilledInput-root": { background: 'rgba(212,175,55,0.1)', borderRadius: 2 },
              "& .MuiFilledInput-root:before": { borderBottom: 'none' },
            }}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />

          <TextField
            label="Password"
            type="password"
            variant="filled"
            fullWidth
            sx={{
              mb: 4,
              input: { color: '#fdf6e3' },
              label: { color: 'rgba(253,246,227,0.8)' },
              "& .MuiFilledInput-root": { background: 'rgba(212,175,55,0.1)', borderRadius: 2 },
              "& .MuiFilledInput-root:before": { borderBottom: 'none' },
            }}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <Button
            variant="contained"
            sx={{
              py: 1.5,
              borderRadius: 5,
              fontWeight: 'bold',
              textTransform: 'none',
              backgroundColor: '#d4af37',
              color: '#1a2a4f',
              "&:hover": { backgroundColor: '#c9b37e', transform: 'scale(1.05)' },
              boxShadow: '0 0 20px rgba(212,175,55,0.6)',
              transition: 'all 0.3s ease',
            }}
            fullWidth
            type="submit"
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Register'}
          </Button>
        </form>

        <Typography variant="caption" display="block" sx={{ mt: 4, opacity: 0.6 }}>
          <a href="/login" style={{ color: '#fdf6e3', textDecoration: 'underline' }}>
            I already have an account
          </a>
        </Typography>
      </Paper>

      <style>{`
        @keyframes fall {
          0% { transform: translateY(-200px) rotate(0deg); opacity: 0.5; }
          50% { opacity: 1; }
          100% { transform: translateY(110vh) rotate(360deg); opacity: 0; }
        }
      `}</style>
    </Box>
  );
}

export default Register;
